import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import { CBadge } from "@coreui/react-pro";
import AuthService from "./modules/auth/redux/AuthService";
import { 
  GET_ACTIVITIES, 
  GET_ACTIVITY_COUNT,
  GET_SELF_REPORT_PREVIEW_COUNT,
  GET_FORMAL_REVIEW_COUNT,
  GET_EVALUATION_COUNT,
  GET_EVALUATOR_REPORTS_COUNT,
  GET_DRAFT_REPORT_COUNT,
  GET_FINAL_REPORT_COUNT,
  GET_APPLICATIONS_COUNT,
  GET_SELF_REPORT_COUNT,
  GET_MONTH_RESPONSE_COUNT,
  GET_APPLICATION_LOOP_COUNT,
  GET_CONSISTENCY_COUNT,
  GET_EDITOR_COUNT,
  GET_SPELLING_CONTROL_COUNT,
  GET_CONSISTENCY_FINAL_REPORT_COUNT
} from "src/setup/apollo/queries";
import { useApolloClient } from "@apollo/client";

export const AppSidebarNav = ({ items }) => {
  const [isShow, setIsShow] = useState(false);
  const [newItems, setNewItems] = useState([]);
  const [badgeCounts, setBadgeCounts] = useState({});
  const role = AuthService.GetCurrentUser()?.userData.roles;
  const salesPersonGuid = AuthService.GetCurrentUser().salesPersonGuid;
  const salesPersonId = AuthService.GetCurrentUser()?.userData.salesPersonId;
  const client = useApolloClient();
  const _activityTypeGuid = "07EF8AFD-4944-4DB0-9773-E9A0A0CBD9CB";
  let usr = {
    role: role,
  };

  console.log("first", newItems);

  let newArray = [];
  //will set
  // will createSalesperson
  const _loadDataAtCursor = async (cursor) => {
    try {
      return await client.query({
        query: GET_ACTIVITIES,
        variables: {
          cursor,
          salesPersonGuid: salesPersonGuid,
          activityTypeGuid: _activityTypeGuid,
        },
      });
    } catch (e) {}
  };

  // Generic function to load count using any query
  const loadCountGeneric = async (query, role) => {
    console.log("QQQQquery",query)
    try {
      const result = await client.query({
        query: query(role),
        variables: { value: query == GET_MONTH_RESPONSE_COUNT || query == GET_SELF_REPORT_COUNT || query == GET_EDITOR_COUNT ? parseInt(salesPersonId) : salesPersonId?.toString() || "" }
      });
      console.log("QQQQresult",result)
      if (query == GET_MONTH_RESPONSE_COUNT || query == GET_CONSISTENCY_COUNT || query == GET_EDITOR_COUNT || query == GET_SELF_REPORT_COUNT) {
        console.log("QQQQresult",result?.data?.activities?.totalCount)
        return result?.data?.activities?.totalCount || 0;
      } else {
        return result?.data?.activityStatements?.totalCount || 0;
      }
    } catch (e) {
      console.error("Error loading count:", e);
      return 0;
    }
  };

  // Original loadActivityCount function for backward compatibility
  const loadActivityCount = async () => {
    return await loadCountGeneric(GET_ACTIVITY_COUNT, role);
  };

  // Comprehensive badge count function
  const getBadgeCount = async (name) => {
    try {
      let count = 0;
      console.log("GGGGGGGG",name)
      switch(name) {
        case "Şekilsel İnceleme":
          count = await loadCountGeneric(GET_FORMAL_REVIEW_COUNT, role);
          break;
        case "Değerlendirme":
          count = await loadCountGeneric(GET_EVALUATION_COUNT, role);
          break;
        case "Değerlendirme Çizelgesi teamLeader":
          console.log("GGGGGGGG",["TB"])
          count = await loadCountGeneric(GET_SELF_REPORT_PREVIEW_COUNT, ["TB"]);
          break;
        case "Değerlendirme Çizelgesi evaluator":
          console.log("GGGGGGGG",["Değerlendirici"])
          count = await loadCountGeneric(GET_SELF_REPORT_PREVIEW_COUNT, ["Değerlendirici"]);
          break;
        case "Değerlendirme Çizelgesi watcher":
          console.log("GGGGGGGG",["Gözlemci"])
          count = await loadCountGeneric(GET_SELF_REPORT_PREVIEW_COUNT, ["Gözlemci"]);
          break;
        case "Değerlendirme Çizelgesi student":
          console.log("GGGGGGGG",["Öğrenci"])
          count = await loadCountGeneric(GET_SELF_REPORT_PREVIEW_COUNT, ["Öğrenci"]);
          break;
        case "Taslak Rapor":
          count = await loadCountGeneric(GET_DRAFT_REPORT_COUNT, role);
          break;
        case "Kesin Rapor":
          count = await loadCountGeneric(GET_FINAL_REPORT_COUNT, role);
          break;
        case "Tutarlılık Kesin Raporu":
          count = await loadCountGeneric(GET_CONSISTENCY_FINAL_REPORT_COUNT, role);
          break;
        case "Başvurular":
          count = await loadCountGeneric(GET_APPLICATIONS_COUNT, role);
          break;
        case "Öz D. Raporu":
          count = await loadCountGeneric(GET_SELF_REPORT_COUNT, role);
          break;
        case "30 Gün Yanıtı":
          count = await loadCountGeneric(GET_MONTH_RESPONSE_COUNT, role);
          break;
        case "SAK'tan Geri Dönen Programlar":
          count = await loadCountGeneric(GET_APPLICATION_LOOP_COUNT, role);
          break;
        case "Program Raporları":
          count = await loadCountGeneric(GET_CONSISTENCY_COUNT, role);
          break;
        case "Yazım Kontrol":
          count = await loadCountGeneric(GET_SPELLING_CONTROL_COUNT, role);
          break;
        case "Bekleyen Kesin Raporlar":
          count = await loadCountGeneric(GET_EDITOR_COUNT, role);
          break;
        default:
          count = 0;
      }
      
      return count === 0 ? undefined : count;
    } catch (error) {
      console.error("Error in getBadgeCount:", error);
      return undefined;
    }
  };

  // Load all badge counts
  const loadAllBadgeCounts = async () => {
    const navigationItems = [
      "Şekilsel İnceleme", 
      "Değerlendirme",
      "Değerlendirme Çizelgesi teamLeader",
      "Değerlendirme Çizelgesi evaluator",
      "Değerlendirme Çizelgesi watcher",
      "Değerlendirme Çizelgesi student",
      "Taslak Rapor",
      "Kesin Rapor",
      "Başvurular",
      "Tutarlılık Kesin Raporu",
      "Öz D. Raporu",
      "30 Gün Yanıtı",
      "Program Raporları",
      "Yazım Kontrol",
      "Bekleyen Kesin Raporlar"
    ];

    try {
      const counts = {};
      
      // Load counts in parallel for better performance
      const countPromises = navigationItems.map(async (itemName) => {
        const count = await getBadgeCount(itemName);
        return { itemName, count };
      });

      const results = await Promise.all(countPromises);
      
      results.forEach(({ itemName, count }) => {
        if (count !== undefined) {
          counts[itemName] = count;
        }
      });

      setBadgeCounts(counts);
      console.log("Badge counts loaded:", counts);
    } catch (error) {
      console.error("Error loading badge counts:", error);
    }
  };

  // Function to refresh badge counts (can be called from external components)
  const refreshBadgeCounts = () => {
    loadAllBadgeCounts();
  };

  // Expose refresh function globally (optional)
  React.useEffect(() => {
    window.refreshNavigationBadges = refreshBadgeCounts;
    return () => {
      delete window.refreshNavigationBadges;
    };
  }, []);

  async function loadActivities() {
    var cursor = undefined;
    var buffer = [];
    async function query() {
      let result = await _loadDataAtCursor(cursor);
      if (result.error) {
        return false;
      }
      const pi = result.data?.activities?.pageInfo;
      if (!pi) return false;
      let activities = result.data.activities.edges.map((r) => r.node);
      buffer.push(...activities);
      cursor = pi.endCursor;
      return pi.hasNextPage;
    }
    var hasMore = true;
    while (hasMore === true) {
      hasMore = await query();
    }

    buffer.map((element) =>
      element.childActivities.map((el) => {
        el.activityStatus.guid == "9abd0bb9-3c89-432f-bad7-532666dcfaa5" &&
          newArray.push(element);
      })
    );

    if (newArray.length != 0) {
      setIsShow(true);
    } else {
      setIsShow(false);
    }
  }


  /* const kurum = role.includes("Kurum");
  const teamLeader = role.includes("TB");
  const editor = role.includes("Editor");
  const consistency = role.includes("TKK");
  const spelling = role.includes("YKK");
  const evaluator = role.includes("Degerlendirici");
  if (kurum) {
    usr.role = "organisation";
  } else if (teamLeader) {
    usr.role = "teamLeader";
  } else if (editor) {
    usr.role = "editor";
  } else if (consistency) {
    usr.role = "consistency";
  } else if (spelling) {
    usr.role = "spelling";
  } else if (evaluator) {
    usr.role = "evaluator";
  } */

  const admin = role.includes("admin");
  const kurum = role.includes("Kurum");
  const teamLeader = role.includes("TB");
  const editor = role.includes("Editor");
  const consistency = role.includes("TKK");
  const spelling = role.includes("YKK");
  const evaluator = role.includes("Degerlendirici");
  const student = role.includes("Öğrenci");
  const watcher = role.includes("Gözlemci");

  // Create array of user roles instead of single role
  usr.roles = [];
  if (admin) usr.roles.push("admin");
  if (kurum) usr.roles.push("organisation");
  if (teamLeader) usr.roles.push("teamLeader");
  if (editor) usr.roles.push("editor");
  if (consistency) usr.roles.push("consistency");
  if (spelling) usr.roles.push("spelling");
  if (evaluator) usr.roles.push("evaluator");
  if (student) usr.roles.push("student");
  if (watcher) usr.roles.push("watcher");

  // Keep backwards compatibility with single role
  if (admin) {
    usr.role = "admin";
  } else if (kurum) {
    usr.role = "organisation";
  } else if (teamLeader) {
    usr.role = "teamLeader";
  } else if (editor) {
    usr.role = "editor";
  } else if (consistency) {
    usr.role = "consistency";
  } else if (spelling) {
    usr.role = "spelling";
  } else if (evaluator) {
    usr.role = "evaluator";
  } else if (student) {
    usr.role = "student";
  } else if (watcher) {
    usr.role = "watcher";
  }

  //Herkeste Admin Rolü Var Sıkıntı Orada

  // Filter items based on multiple roles
  const newItems1 = items.filter(
    (item, index) => 
      usr?.roles.includes(item.role) || 
      item.role == "everyone" || 
      usr?.role === item.role
  );

  let newElementArray = [];
  useEffect(() => {
    loadActivities();
    loadAllBadgeCounts(); // Load badge counts on component mount
    setNewItems(newItems1);
  }, []);
  useEffect(() => {
    if (isShow) {
      newItems1.map((element) =>
        element.show == "true"
          ? newElementArray.push(element)
          : isShow == true && newElementArray.push(element)
      );
      setNewItems(newElementArray);
    } else {
      newItems1.map(
        (element) => element.show != "false" && newElementArray.push(element)
      );
      setNewItems(newElementArray);
    }
  }, [isShow]);

  const location = useLocation();
  const navLink = (name, icon, badge) => {
    return (
      <>
        {icon && icon}
        {name && name}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </>
    );
  };

  const navItem = (item, index) => {
    const { component, name, badge, icon, role, ...rest } = item;
    const Component = component;
    
    // Get dynamic badge count for this item
    const dynamicBadgeCount = badgeCounts[name == "Değerlendirme Çizelgesi" ? "Değerlendirme Çizelgesi" + " " + role : name];
    const finalBadge = dynamicBadgeCount ? 
      { color: "danger", text: dynamicBadgeCount.toString() } : 
      badge; // Fall back to static badge if no dynamic count
    
    return (
      <Component
        {...(rest.to &&
          !rest.items && {
            component: NavLink,
            //activeClassName: 'active',
          })}
        key={index}
        onClick={() => {
          localStorage.setItem("clickedRole", role);
        }}
        {...rest}
      >
        {navLink(name, icon, finalBadge)}
      </Component>
    );
  };
  const navGroup = (item) => {
    const { component, index, name, icon, to, role, ...rest } = item;
    const Component = component;
    
    // Get badge count for the group (sum of all items in the group)
    const getGroupBadgeCount = (items) => {
      if (!items) return undefined;
      
      let totalCount = 0;
      items.forEach(item => {
        if (item.items) {
          // Recursive for nested groups
          const nestedCount = getGroupBadgeCount(item.items);
          if (nestedCount) totalCount += nestedCount;
        } else {
          // Add individual item count
          const itemCount = badgeCounts[item.name == "Değerlendirme Çizelgesi" ? "Değerlendirme Çizelgesi" + " " + role : item.name];
          if (itemCount) totalCount += itemCount;
        }
      });
      
      return totalCount > 0 ? totalCount : undefined;
    };
    
    const groupBadgeCount = getGroupBadgeCount(item.items);
    const groupBadge = groupBadgeCount ? 
      { color: "danger", text: groupBadgeCount.toString() } : 
      undefined;
    
    return (
      <>
        <Component
          idx={String(index)}
          key={index}
          toggler={navLink(name, icon, groupBadge)}
          visible={location.pathname.startsWith(to)}
          {...rest}
        >
          {item.items?.map((item, idx) => 
            item.items ? navGroup(item) : navItem(item, idx)
          )}
        </Component>
      </>
    );
  };

  return (
    <React.Fragment>
      {newItems &&
        newItems
          .filter(
            (item) =>
              !role.includes("Kurum") ||
              item.name !== "ÖDR Değerlendirme Çizelgesi"
          )
          .map((item) => item.items ? navGroup(item) : navItem(item))
      }
      </React.Fragment>
  );
};

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
};